












































































import { ImportacaoDeNota } from '@/models/ImportacaoDeNota'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component({
	components: {
	},
})
export default class DialogoDeRelacaoDeProdutosPaiParaEntradaDaNota extends Vue {

	mostrar = false

	@Prop({ type: Array, required: true, default: () => [] }) produtos!: any[]
	@Prop({ type: String, default: 'id' }) itemKey!: string
	@Prop({ type: Array, default: () => [] }) itensExistentes!: Array<{ id: string | number; nome: string }>

	filtro: string | null = null
	selecionados: any[] = []

	relacionamentos: Record<string | number, { modo: 'nenhum' | 'referencia' | 'existente'; referenciaPai?: string; idItemExistente?: string | number }> = {}
	importacaoDeNota: ImportacaoDeNota | null = null

	get headers () {
		return [
			{ text: 'Produto', value: 'nome', align: 'start' },
			{ text: 'Relacionamento', value: 'acao', sortable: false },
			{ text: 'Referência pai', value: 'referenciaPai', sortable: false },
			{ text: 'Item existente', value: 'itemExistente', sortable: false },
		]
	}

	get opcoesDeRelacionamento () {
		return [
			{ text: 'Sem relacionamento', value: 'nenhum' },
			{ text: 'Usar referência pai', value: 'referencia' },
			{ text: 'Apontar item existente', value: 'existente' },
		]
	}

	getItemId (item: any): string | number {
		return item?.[this.itemKey]
	}

	mounted() {
		this.inicializarRelacionamentos()
	}

	@Watch('produtos', { immediate: false })
	onProdutosAlterados() {
		this.inicializarRelacionamentos()
	}

	inicializarRelacionamentos() {
		(this.produtos || []).forEach(p => {
			const id = this.getItemId(p)
			if (id != null && this.relacionamentos[id] == null) {
				this.$set(this.relacionamentos, id, { modo: 'nenhum' })
			}
		})
	}

	mostrarDialogo(importacaoDeNota?: ImportacaoDeNota){
		this.importacaoDeNota = importacaoDeNota ?? null
		this.mostrar = true

	}

	esconderDialogo(){
		this.mostrar = false
	}

	onCancelar(){
		this.esconderDialogo()
		this.$emit('cancelar')
	}

	onConfirmar(){
		const payload = this.selecionados.map((item: any) => {
			const id = this.getItemId(item)
			const rel = this.relacionamentos[id] || { modo: 'nenhum' }
			return {
				id,
				item,
				modo: rel.modo,
				referenciaPai: rel.referenciaPai || null,
				idItemExistente: rel.idItemExistente || null,
			}
		})
		this.$emit('confirmar', payload)
		this.esconderDialogo()
	}

}
